/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('SbfTimeSlotDialogController', SbfTimeSlotDialogController);

    SbfTimeSlotDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'entityProject', 'SbfTimeSlot', 'Profile', '$http', 'ProjectDetailBooking'];

    function SbfTimeSlotDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, entityProject, SbfTimeSlot, Profile, $http, ProjectDetailBooking) {
        var vm = this;
        vm.sbfTimeSlot = entity;
        vm.sbfTimeSlot.project = {id:$stateParams.id};
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.slotDuration = [1, 30];
        vm.isExam = false;

        $scope.selectFromDate = function() {
            vm.isExam = false;
            if(!vm.sbfTimeSlot.fromTime) {
                return;
            }
            var defaultEndTime = angular.copy(vm.sbfTimeSlot.fromTime);
            defaultEndTime.setHours(defaultEndTime.getHours() + vm.slotDuration[0]);
            defaultEndTime.setMinutes(defaultEndTime.getMinutes() + vm.slotDuration[1]);
            vm.sbfTimeSlot.toTime = defaultEndTime;
            $scope.options = {
                minDate: new Date(vm.sbfTimeSlot.fromTime),
                initDate: new Date(defaultEndTime)
            };

            vm.isExam = vm.sbfTimeSlot.fromTime > entityProject.untilDate;
            if (vm.sbfTimeSlot.fromTime && vm.isExam && !vm.sbfTimeSlot.instructor) {
                vm.sbfTimeSlot.instructor = vm.profileExaminer;
            }
        };

        ProjectDetailBooking.query({
                page: 0,
                size: 999,
                sort: ["profile.user.lastName,asc", "profile.user.firstName,asc"],
                projectID: $stateParams.id
            }, function(data) {
                vm.profiles = data;
            }, function() {
        });

        vm.getUser = getUser;

        vm.profileExaminer = null;
        getExaminer();
        function getExaminer() {
            return $http.get('api/member/examiner', {}).then(function(response){
                vm.profileExaminer = response.data;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sbfTimeSlot.id !== null) {
                SbfTimeSlot.update(vm.sbfTimeSlot, onSaveSuccess, onSaveError);
            } else {
                SbfTimeSlot.save(vm.sbfTimeSlot, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:sbfTimeSlotUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromTime = false;
        vm.datePickerOpenStatus.toTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getUser(val) {
            return $http.get('api/_search/profiles_guest/', {
                params: {
                    query: val
                }
            }).then(function(response){
                return response.data.map(function(item) {
                    return item;
                });
            });
        }
    }
})();
